import React from 'react';
import MentoringCourseTicketHistory from 'components/user/parts/MentoringCourseTicketHistory';
import PurchaseHistory from 'components/user/parts/PurchaseHistory';
import { CWindowWidth } from 'constants/base.const';
import styled from 'styled-components';
import { PrimaryColor, device } from 'GlobalStyles';

const UserCreditWrapper = styled.div`
  padding-bottom: 200px;
  .btn-default {
    background: #fff !important;
    border-color: ${PrimaryColor} !important;
  }
`;
const UserCourseUsageHistory = () => {
  return (
    <UserCreditWrapper>
      <div
        style={{
          maxWidth: `${CWindowWidth - 300}px`,
          margin: 'auto',
          padding: '40px 10px 0px 10px',
        }}
      >
        <StyledTitle>수강권 사용내역</StyledTitle>
        <StyledHistoryWrapper>
          <StyledCourseHistoryList>
            <MentoringCourseTicketHistory />
          </StyledCourseHistoryList>
          <StyledPurchaseList>
            <PurchaseHistory />
          </StyledPurchaseList>
        </StyledHistoryWrapper>
      </div>
    </UserCreditWrapper>
  );
};

export default UserCourseUsageHistory;

export const StyledTitle = styled.div`
  font-size: 30px;
  @media screen and ${device.md} {
    font-size: 20px;
  }
`;

const StyledHistoryWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  @media screen and ${device.md} {
    flex-direction: column;
  }
`;

const StyledCourseHistoryList = styled.section`
  width: 50%;
  @media screen and ${device.md} {
    width: unset;
  }
`;

const StyledPurchaseList = styled.section`
  width: 50%;
  @media screen and ${device.md} {
    width: unset;
  }
`;
